import "./DisplayBoard.css"
import FadeIn from 'react-fade-in';
import React, { useRef, useState, useEffect } from "react";
import AuthService from "../services/auth.service";
// import { useInterval } from 'usehooks-ts';

const sendIntSec = 5000;

function DisplayBoard({ isPlaying, isNextQuestion, questionNum, setFetchedAnswers, setIsPlaying }) {

  const [hintsQ, setHintsQ] = useState([]);

  useEffect(() => {
    return () => {
      setHintsQ([]);
    };
  }, []);


  const genText = () => {
    const ret = [];
    // do not gen text to display when transiting to the next question
    if (isNextQuestion) return ret;
    hintsQ.forEach((elem, idx) => {
      if (elem) {
        ret.push(
          <FadeIn key={`key${idx}`}>
            <div className={"hint"} style={{ fontSize: "18px", marginTop: "1vh", marginBottom: "1vh" }}>
              &#x2022; {elem}
            </div>
          </FadeIn>
        );
      }
    });
    return ret;
  }

  const isInit = (renew, questionNum) => {
    return (renew && questionNum == 1) ? 1 : 0;
  }

  useEffect(() => {
    if (isPlaying) {
      const interval = setInterval(() => {
        gameplay(false);
      }, sendIntSec);
      return () => clearInterval(interval);
    }
  }, [isPlaying])

  useEffect(() => {
    console.log("[info] restart gameplay")
    gameplay(true);
  }, [questionNum]);

  const gameplay = (renew) => {
    console.log('[info] enter gameplay function, renew:', renew);

    AuthService.gameplay("getQuestion",
      {
        "questionNum": questionNum,
        'init': isInit(renew, questionNum)
      }
    )
      .then(async (res) => {
        console.log('get Q res',res.data)
        setHintsQ(prev => renew ? [res.data['hint']] : [...prev, res.data['hint']]);
        if ('ans' in res.data) {
          setFetchedAnswers(res.data['ans']);
        }
        if (renew) setIsPlaying(true);
      })
      .catch((err) => {
        console.error('err: question fetch', err);
      });
  }

  return (
    <div className="display-board">
      {genText()}
    </div>
  );
}

export default DisplayBoard;